var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({staticClass:"carousel-item",class:{ active: _vm.isActive }},'div',_vm.$attrs,false),[_c('div',{staticClass:"carousel-caption"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }